import { CardSlash, Lovely, Medal, MedalStar, Routing } from "iconsax-react";
import React from "react";

const SavingsGoalsSection = () => {
  const bgImageOne = "./assets/dark.svg";
  const bgImageTwo = "./assets/greenNet2.svg";
  const bgImageThree = "./assets/whitenet.svg";

  return (
    <section className="w-full py-16 px-6 md:px-16 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-lg md:text-2xl lg:text-[28px] xl:text-3xl font-bold max-w-sm md:max-w-lg lg:max-w-[560px] mx-auto text-center mb-4">
          Do you want more money for your future goals?
        </h2>
        <p className="text-center text-[#6F6F6F] max-w-sm md:max-w-lg lg:max-w-xl mx-auto mb-16">
          Vant helps you stay on track. Save solo or team up with others through
          our flexible group saving options.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div
            className=" relative rounded-3xl pt-5  md:pt-9 lg:pt-12 pb-4  md:pb-7 lg:pb-10 h-[300px] md:h-[400px]"
            style={{
              backgroundImage: `url('${bgImageOne}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="flex justify-center items-center ">
              <img
                src={"./assets/personalsavings.svg"}
                alt="group-img"
                fill
                className=" w-[70%] lg:w-[60%] h-[100px] lg:h-[160px] xl:h-[180px]"
              />
            </div>

            <div className="text-white text-center mt-6 md:mt-7 px-4">
              <p className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold ">
                Personal Saving
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%] mx-auto px-4 mt-2">
                Take control of your financial future by saving at your own
                pace. Set personal goals, automate your savings, and track your
                progress.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6 h-[300px] md:h-[400px]">
            <div
              className=" relative rounded-[18px] md:rounded-3xl py-6 md:py-7 lg:py-8 px-4 md:px-5 lg:px-6  md:h-[190px]"
              style={{
                backgroundImage: `url('${bgImageTwo}')`,
                backgroundPosition: "center 100%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                transition: "background-image 1s ease-out",
              }}
            >
              <MedalStar
                color="#fff"
                size="20"
                className="mb-2 md:mb-2  md:mt-2"
              />
              <p className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold text-white  ">
                Personal Saving
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]   mt-2 text-white">
                Plan for tomorrow, today. Use the vant app to set retirement
                goals, automate your savings, and build a more secure future—one
                contribution at a time.
              </p>
            </div>

            <div
              className=" relative rounded-[18px] md:rounded-3xl py-6 md:py-7 lg:py-8 px-4 md:px-5 lg:px-6  md:h-[190px]"
              style={{
                backgroundImage: `url('${bgImageThree}')`,
                backgroundPosition: "center 100%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                transition: "background-image 1s ease-out",
              }}
            >
              <Lovely
                color="#32AE4C"
                size="20"
                className="mb-2 md:mb-2  md:mt-2"
              />
              <p className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold text-[#020617]  ">
                Save for health insurance{" "}
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]   mt-2 text-[#6F6F6F]">
                Stay prepared for medical costs by setting money aside in the
                vant app. Save a little at a time and be ready when you need
                coverage the most.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col-reverse md:flex-row gap-8 mb-8">
          <div className="w-full md:w-[50%] grid grid-cols-1 gap-6 h-[300px] md:h-[400px]">
            <div
              className=" relative rounded-[18px] md:rounded-3xl py-6 md:py-7 lg:py-8 px-4 md:px-5 lg:px-6  md:h-[190px]"
              style={{
                backgroundImage: `url('${bgImageThree}')`,
                backgroundPosition: "center 100%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                transition: "background-image 1s ease-out",
              }}
            >
              <Routing
                color="#32AE4C"
                size="20"
                className="mb-2 md:mb-2  md:mt-2"
              />
              <p className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold text-[#020617]  ">
                Save for vacation{" "}
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]   mt-2 text-[#6F6F6F]">
                Set money aside for your next vacation—right in the app. Track
                your goal, save automatically, and get there faster.
              </p>
            </div>
            <div
              className=" relative rounded-[18px] md:rounded-3xl py-6 md:py-7 lg:py-8 px-4 md:px-5 lg:px-6  md:h-[190px]"
              style={{
                backgroundImage: `url('${bgImageTwo}')`,
                backgroundPosition: "center 100%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                transition: "background-image 1s ease-out",
              }}
            >
              <CardSlash
                color="#fff"
                size="20"
                className="mb-2 md:mb-2   md:mt-2"
              />
              <p className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold text-white  ">
                Save to pay off debt{" "}
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]   mt-2 text-white">
                Use the vant app to set money aside and chip away at your debt.
                Stay on track, build momentum, and get closer to being
                debt-free—one step at a time.
              </p>
            </div>
          </div>

          <div
            className="w-full md:w-[50%]  relative rounded-3xl pt-5  md:pt-9 lg:pt-12 pb-4  md:pb-7 lg:pb-10 h-[300px] md:h-[400px]"
            style={{
              backgroundImage: `url('${bgImageOne}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="relative flex justify-center items-center ">
              <img
                src={"./assets/groupsave.svg"}
                alt="group-img"
                fill
                className=" w-[70%] lg:w-[60%] h-[100px] lg:h-[160px] xl:h-[180px]"
              />

              <img
                src={"./assets/p1.svg"}
                alt="-img"
                fill
                className="absolute -top-4 left-0 h-[80px] lg:h-[100px] xl:h-[110px]"
              />

              <img
                src={"./assets/p2.svg"}
                alt="-img"
                fill
                className="absolute -top-4 right-0 h-[80px] lg:h-[100px] xl:h-[110px]"
              />

              <img
                src={"./assets/p3.svg"}
                alt="-img"
                fill
                className="absolute bottom-0 left-4 h-[80px] lg:h-[100px] xl:h-[110px]"
              />

              <img
                src={"./assets/p4.svg"}
                alt="-img"
                fill
                className="absolute bottom-0 right-4 h-[80px] lg:h-[100px] xl:h-[110px]"
              />
            </div>

            <div className="text-white text-center mt-6 md:mt-7 px-4">
              <p className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold ">
                Group Saving On Vant{" "}
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%] mx-auto px-4 mt-2">
                Collaborate with friends, family, or a community to achieve
                shared financial goals. Pool your resources, hold each other
                accountable, and make saving more engaging.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SavingsGoalsSection;
